'use strict';

angular.module('cimerFrontEndApp').controller('DownloadGrantDetailsCtrl', ['$scope', 'ReportService', 'Session', function ($scope, ReportService, Session) {

    var sessionObject = Session.getSessionObject();
    if (!sessionObject.isAuthenticated || !sessionObject.isAdmin) {
        $location.url('/');
        return;
    }
    $scope.startDate = null;
    $scope.endDate = null;
    $scope.formSubmitted = false;

    $scope.downloadData = function () {
        if (!this.grantDetailsForm.$valid) {
            $scope.formSubmitted = true;
            return;
        }
        $scope.formSubmitted = false;
        ReportService.downloadGrantDetailsCsv(formatDate($scope.startDate), formatDate($scope.endDate));
    };

    var formatDate = function (dateVal) {
        if (dateVal === null) {
            return null;
        }
        var date = new Date(dateVal);
        var month = date.getMonth() + 1
        var temp = date.getFullYear() + "-" + month + "-" + date.getDate();
        return temp;
    }
}]);